module.exports = __webpack_public_path__ + "static/media/blueDiamond.b649cdaf.png";